export default (function () {
  /*
   * 日期格式化
   * 默认格式：yyyy-MM-dd
   */
  var format = function (date, fmt) {
    if (date === null || date === undefined) {
      return date
    }
    date = (typeof date === 'number' ? new Date(date) : date)
    fmt = fmt || 'yyyy-MM-dd'
    var o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      'S': date.getMilliseconds()
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  }

  var formatDiffer = function (date) {
    if (date === null) {
      return date
    }
    date = (typeof date === 'number' ? new Date(date) : date)
    var msDiffer = date.getTime() - new Date().getTime()
    var symbol = msDiffer < 0 ? '-' : ''
    msDiffer = Math.abs(msDiffer)
    if (msDiffer < 1000) {
      return '小于' + symbol + '1秒'
    } else if (msDiffer / 1000 < 60) {
      // 秒
      return symbol + (msDiffer / 1000).toFixed(0) + '秒'
    } else if (msDiffer / 1000 / 60 < 60) {
      // 分
      return symbol + (msDiffer / 1000 / 60).toFixed(0) + '分钟'
    } else if (msDiffer / 1000 / 60 / 60 < 24) {
      // 时
      return symbol + (msDiffer / 1000 / 60 / 60).toFixed(0) + '小时'
    } else if (msDiffer / 1000 / 60 / 60 / 24 < 100) {
      // 天
      return symbol + (msDiffer / 1000 / 60 / 60 / 24).toFixed(0) + '天'
    } else {
      return '超过' + symbol + '99天'
    }
  }

  var format2HommizationDate = function (date) {
    if (date === null) {
      return date
    }
    var dateTrimed = (typeof date === 'number' ? new Date(date) : date)
    dateTrimed = new Date(date.getFullYear(), date.getMonth(), date.getDay())
    var nowTrimed = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDay())
    var dayDiffer = ((dateTrimed.getTime() - nowTrimed.getTime()) / 1000 / 60 / 60 / 24).toFixed(0)
    if (dayDiffer === '0') {
      return '今天'
    } else if (dayDiffer === '1') {
      return '明天'
    } else if (dayDiffer === '2') {
      return '后天'
    } else if (dayDiffer === '-1') {
      return '昨天'
    } else if (dayDiffer === '-2') {
      return '前天'
    } else if (Number(dayDiffer) > 0) {
      return dayDiffer + '天后'
    } else if (Number(dayDiffer) < 0) {
      return Math.abs(Number(dayDiffer)) + '天前'
    }
  }

  return {
    format: format,
    formatDiffer: formatDiffer,
    format2HommizationDate: format2HommizationDate
  }
})()



// WEBPACK FOOTER //
// ./src/baize/src/DateUtil.js